import { getAccountClassForType } from "@common/constants/domains/accounting/helpers";
import { AccountType } from "@common/constants/domains/accounting/accounts";
import { AccountGroup } from "@common/types/domains/accounting/account";
import {
    AccountMergeStatus,
    PreviewAccountChange,
    PreviewAccountOrigin,
} from "@common/types/domains/accounting/chartOfAccountsTemplateApply";
import { CoaApplyVariableMappingChange } from "@common/types/domains/accounting/chartOfAccountsTemplateApplyEvent";
import {
    FALLBACK_SUBTYPE,
    type PreviewExtendedAccount,
} from "./applyCoaTemplatePreviewMapper";

export interface HistoricalCoaViewModel {
    accounts: PreviewExtendedAccount[];
    groups: AccountGroup[];
    newGroupIds: Set<string>;
    variableMappingChanges: CoaApplyVariableMappingChange[];
    isEmpty: boolean;
}

export function formatHistoricalGroupPath(groupPath: string[]): string | null {
    return groupPath.length > 0 ? groupPath.join(" / ") : null;
}

interface HistoricalAccountRowInput {
    id: string;
    code: number;
    codeText: string | null;
    name: string;
    type: AccountType;
    isDisabled: boolean;
    isManuallyCreated: boolean;
    parentGroupId: string | null;
    sortOrder: number;
    mergeStatus: AccountMergeStatus;
    changes: PreviewAccountChange[];
    wasArchivedByApply: boolean;
    previousGroupPath: string | null;
}

export function buildHistoricalAccountRow(
    input: HistoricalAccountRowInput,
): PreviewExtendedAccount {
    return {
        id: input.id,
        code: input.code,
        codeText: input.codeText,
        name: input.name,
        class: getAccountClassForType(input.type),
        type: input.type,
        subtype: FALLBACK_SUBTYPE,
        isDisabled: input.isDisabled,
        isManuallyCreated: input.isManuallyCreated,
        financialAccountId: null,
        kickOriginalCode: null,
        parentGroupId: input.parentGroupId,
        sortOrder: input.sortOrder,
        debit: 0,
        credit: 0,
        balance: 0,
        entityId: 0,
        hasOpeningBalance: false,
        mergeStatus: input.mergeStatus,
        previousCode: null,
        origin: PreviewAccountOrigin.matched,
        changes: input.changes,
        wasArchivedByApply: input.wasArchivedByApply,
        previousGroupPath: input.previousGroupPath,
    };
}
